// extracted by mini-css-extract-plugin
export default {"wrapper":"laa","container":"maa","title":"naa","carousel":"oaa","review":"paa","name":"qaa","rating":"raa","heading":"saa","body":"taa"};
    if(module.hot) {
      // 1714442371891
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  